import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { TranslationRequestDto } from '@app/data/dtos/content-translator/content-translador.dto';
import { TranslateDto } from '@app/data/dtos/content-translator/content-translator.dto';
import { mapContentTranslator } from '@app/data/mappers/content-translator/content-translator.mapper';
import { ContentTranslateRepository } from '@app/domain/repositories/content-translate/content-translate.repository.contract';
import { ENV } from '@environments/environment';

import { MRepository } from '@mercadona/core/utils/repository';

@Injectable({
  providedIn: 'root'
})
export class ContentTranslateRepositoryImpl extends MRepository implements ContentTranslateRepository {
  constructor() {
    super(`${ENV.API_URL}`);
  }

  translate(translationRequest: TranslationRequestDto): Observable<string> {
    const request = {
      body: translationRequest
    };

    return this.post<TranslateDto>('/translate', request).pipe(map(mapContentTranslator));
  }
}
